import { Component, Input } from '@angular/core';
import { Conference } from '@core/models/conference.model';

@Component({
  selector: 'app-single-live-block',
  templateUrl: './single-live-block.component.html',
  styleUrl: './single-live-block.component.css',
})
export class SingleLiveBlockComponent {
  @Input() live?: Conference;

  @Input() showDate = false;

  formatDate(date?: string | null): string {
    if (!date) return 'N/A';

    const [year, month, day] = date.split('-');

    const d = new Date(Number(year), Number(month) - 1, Number(day));

    return d.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    });
  }
}
